import gql from 'graphql-tag';
import apollo from 'src/features/apolloCustomer';

const query = gql`
query currentCustomer {
  me {
    id
    identified
    firstName
    lastName
    description
    accounts {
      id
      provider
      providerId
    }
  }
}`;

function parseAccount(item) {
  return {
    id: item.id,
    title: item.providerId,
    type: item.provider,
  };
}

function parseCustomer(item) {
  return {
    id: item.id,
    title: item.firstName,
    firstName: item.firstName,
    lastName: item.lastName,
    description: item.description,
    identified: !!item.identified,
    accounts: (item.accounts && item.accounts.map((res) => parseAccount(res))) || [],
  };
}

function getCurrentCustomer() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => parseCustomer(res.data.me));
}

export default getCurrentCustomer;
